import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
import buttonBase from './_buttonBase';
import debounce from 'lodash.debounce'; // Set some constants and a shared state variable across all instances of wake lock button

var timerDurationMs = 3600000;
var scrollDebounceMs = 1000;
var initialEventFired = false;
var wakeLockButton = {
  extends: buttonBase,
  // Here are some properties, set by the calling view
  props: {
    inToolbar: {
      type: Boolean,
      default: true
    }
  },
  // This returns the component's data items
  data: function data() {
    return {
      supported: false,
      isInitialized: false,
      isChecked: false,
      isInToolbar: true,
      timerId: 0,
      displayName: this.button ? this.button.displayName : ''
    };
  },
  // Entry point if directly on the page; wake lock support has already been confirmed in this case
  mounted: function mounted() {
    if (!this.inToolbar) {
      this.$_initPlaceholder();
    }
  },
  // Entry point when in a toolbar; only show the list item if wake lock is supported
  watch: {
    button: function button() {
      if ('wakeLock' in navigator && 'request' in navigator.wakeLock) {
        // Only raise the initial event if it hasn't already by another instance of this component
        if (!initialEventFired) {
          this.$_raiseAnalyticsEvent('Wake Lock Toggle Available');
          initialEventFired = true;
        } // Proceed with initialization


        this.$_initPlaceholder();
      } else {
        // It is not supported, so log a message
        if (window.GeneralMills.debugMode) {
          console.log("Wake lock not supported by browser");
        }

        ;
      }
    }
  },
  methods: {
    // This public method handles the slider click
    onChange: function onChange() {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      if (this.isChecked) {
        this.$_requestWakeLock();
      } else {
        this.$_releaseWakeLock();
      }
    },
    // This private method helps with component initialization
    $_initPlaceholder: function $_initPlaceholder() {
      if (!this.button || this.isInitialized) return; // Assign an event handler for when a wake lock button is toggled

      document.addEventListener('WakeLockEnabled', this.$_wakeLockEnabledListener);
      document.addEventListener('WakeLockDisabled', this.$_wakeLockDisabledListener); // Set some properties, including indicating that wake lock is supported

      this.displayName = this.button.displayName;
      this.isInToolbar = this.inToolbar;
      this.isInitialized = true;
      this.supported = true; // If a wake lock is already set, then dispatch the event to set the toggle

      if (this.$_isWakeLockSet()) {
        document.dispatchEvent(new Event('WakeLockEnabled'));
      }
    },
    // This private method acts as an event handler for when a wake lock toggle is enabled
    $_wakeLockEnabledListener: function $_wakeLockEnabledListener() {
      this.isChecked = true;
    },
    // This private method acts as an event handler for when a wake lock toggle is disabled
    $_wakeLockDisabledListener: function $_wakeLockDisabledListener() {
      this.isChecked = false;
    },
    // This private method will tell us if a wake lock is already set
    $_isWakeLockSet: function $_isWakeLockSet() {
      return typeof window.siteWakeLock !== 'undefined' && window.siteWakeLock !== null;
    },
    // This private method requests a wake lock
    $_requestWakeLock: function () {
      var _$_requestWakeLock = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.$_isWakeLockSet()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return navigator.wakeLock.request('screen');

              case 5:
                window.siteWakeLock = _context.sent;
                // Set up the abort timer
                this.$_handleAbortTimer(); // Add event listeners for visibility and scroll changes

                document.addEventListener('visibilitychange', this.$_handleVisibilityChange);
                window.addEventListener('scroll', debounce(this.$_handleAbortTimer, scrollDebounceMs)); // Dispatch the event so any other wake lock components on the page can act accordingly

                document.dispatchEvent(new Event('WakeLockEnabled')); // Raise the appropriate analytics event

                this.$_raiseAnalyticsEvent('Wake Lock Toggle Enabled'); // Print to the console if we are in debug mode

                if (window.GeneralMills.debugMode) {
                  console.log('Wake Lock Active');
                }

                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);
                this.isChecked = false; // If we are in debug mode, print the error to the console

                if (window.GeneralMills.debugMode) {
                  console.log("Wake Lock Request Error: ".concat(_context.t0.name, ", ").concat(_context.t0.message));
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 14]]);
      }));

      function $_requestWakeLock() {
        return _$_requestWakeLock.apply(this, arguments);
      }

      return $_requestWakeLock;
    }(),
    // This private method releases a wake lock
    $_releaseWakeLock: function () {
      var _$_releaseWakeLock = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!this.$_isWakeLockSet()) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return window.siteWakeLock.release();

              case 4:
                window.siteWakeLock = null;

              case 5:
                // Clear the abort timer
                this.$_handleAbortTimer(); // Clean up the event listeners

                document.removeEventListener('visibilitychange', this.$_handleVisibilityChange);
                window.removeEventListener('scroll', debounce(this.$_handleAbortTimer, scrollDebounceMs)); // Dispatch the event so any other wake lock components on the page can act accordingly

                document.dispatchEvent(new Event('WakeLockDisabled')); // Print to the console if we are in debug mode

                if (window.GeneralMills.debugMode) {
                  console.log('Wake Lock Released');
                }

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                // If we are in debug mode, print the error to the console
                if (window.GeneralMills.debugMode) {
                  console.log("Wake Lock Release Error: ".concat(_context2.t0.name, ", ").concat(_context2.t0.message));
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function $_releaseWakeLock() {
        return _$_releaseWakeLock.apply(this, arguments);
      }

      return $_releaseWakeLock;
    }(),
    // This private method handles the abort timer functionality
    $_handleAbortTimer: function $_handleAbortTimer() {
      // If there is an existing timer, clear it and set to zero
      if (this.timerId !== 0) {
        clearTimeout(this.timerId);
        this.timerId = 0;
      } // Start a new timer, which will be triggered from a toggle enable or scroll event


      if (this.isChecked) {
        this.timerId = setTimeout(this.$_releaseWakeLock, timerDurationMs);
      }
    },
    // This private method handles navigation away from the page or tab
    $_handleVisibilityChange: function $_handleVisibilityChange() {
      if (this.isChecked) {
        this.$_releaseWakeLock();
        this.isChecked = false;
      }
    }
  }
};
export default wakeLockButton;